<template>
  <div class="netin-box">
    <app-header title="服务选择" @goback="goBack"></app-header>
    <div class="module-box" @click="openModule">
      <span>{{currentModule.text}}</span><i class="iconfont iconxiala"></i>
    </div>
    <ul class="netin-list">
      <pull-to :is-top-bounce="false" :is-bottom-bounce="isLoadAll" :bottom-load-method="loadmore">
        <li v-for="(item, index) in orderList" :key="index" @click="chooseStore(item)">
          <div>{{ item.productName }}</div>
          <div>{{`可用：${item.surplusNum}`}}</div>
        </li>
      </pull-to>
    </ul>
  </div>
</template>

<script>
import { commonMixin } from 'common/js/mixin';
import apis from 'api/index';
import PullTo from 'vue-pull-to';
import { mapMutations } from 'vuex';

export default {
  mixins: [commonMixin],
  components: {
    PullTo,
  },
  data() {
    return {
      modulesList: [],
      currentModule: {},
      orderList: [],
      total: 0,
      pageNumber: 1,
      pageSize: 15,
    }
  },
  computed: {
    // 用来控制是否启用下拉刷新
    isLoadAll() {
      return Boolean(this.total > this.pageNumber * this.pageSize);
    },
  },
  created() {
    this.fetchModuleList().then(res => {
      this.modulesList = this._normalizeModule(res);
      this.modulesList.unshift({ id: null, text: '全部模块订单', });
      this.currentModule = this.modulesList[0];
      this.fetchOrderList();
    });
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 打开选择pop
    openModule() {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '选择模块',
          data: [this.modulesList],
          onSelect: this.changeModule,
        })
      }
      this.picker.show();
    },
    changeModule(value) {
      this.currentModule = this.modulesList.filter(item => item.value === value[0])[0];
      this.fetchOrderList('reset');
    },
    chooseStore(item) {
      // 没有门店可配就不让他进去了
      if(item.surplusNum === 0) {
        this.showToast('没有名额');
        return false;
      }
      this.setCurrentOrder(item);
      this.$router.push({path: `/choose-store/${item.moduleId}`, query: {type: 1}});
    },
    loadmore(loaded) {
      if(this.total <= this.pageNumber * this.pageSize) {
        return false;
      }
      this.pageNumber +=1;
      this.fetchOrderList().then(res => {
        loaded('done');
      });
    },
    async fetchOrderList(type = 'normal') {
      try {
        let params = {};
        params.no = this.pageNumber;
        params.limit = this.pageSize;
        params.status = 5;
        params.moduleId = this.currentModule.id;
        const res = await apis.ordersModuleOrder(params);
        if(type === 'normal') {
          this.orderList = this.orderList.concat(res.records);
        } else {
          this.orderList = res.records;
        }
        this.total = res.total;
      } catch(err) {
        console.error(err);
      }
    },
    ...mapMutations(['setCurrentOrder'])
  }
}
</script>

<style src="./netin.scss" lang="scss" scoped></style>
